import { render } from "./CourseList.vue?vue&type=template&id=b5a8baf8&scoped=true"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"

import "./CourseList.vue?vue&type=style&index=0&id=b5a8baf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a8baf8"]])

export default __exports__